"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentKit = void 0;
var common_1 = require("@terra-js/common");
var constansts_1 = require("./constansts");
var PaymentKit = /** @class */ (function () {
    function PaymentKit() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('PaymentKitModule');
    }
    /**
     * @deprecated Should use payForOrder method instead
     */
    PaymentKit.prototype.pay = function (paymentRequest) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule.invoke('pay', paymentRequest).then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    PaymentKit.prototype.payForOrder = function (paymentRequest, appName) {
        var _this = this;
        if (appName === void 0) { appName = null; }
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke('payForOrder', { appName: appName, paymentRequest: paymentRequest })
                .then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                code: constansts_1.UnknownExceptionCode,
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            code: constansts_1.UnknownExceptionCode,
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    PaymentKit.prototype.payForOrderLegacy = function (paymentRequest, appName) {
        var _this = this;
        if (appName === void 0) { appName = null; }
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke('payForOrderLegacy', { appName: appName, paymentRequest: paymentRequest })
                .then(function (response) {
                try {
                    if (response.status_code == 200) {
                        resolve(response.result);
                    }
                    else {
                        resolve({
                            resultCode: constansts_1.ResultCode.Failed,
                            error: {
                                code: constansts_1.UnknownExceptionCode,
                                message: response.error,
                            },
                        });
                    }
                }
                catch (error) {
                    resolve({
                        resultCode: constansts_1.ResultCode.Failed,
                        error: {
                            code: constansts_1.UnknownExceptionCode,
                            message: error.message || constansts_1.UnknownExceptionMessage,
                        },
                    });
                }
            });
        });
    };
    return PaymentKit;
}());
exports.PaymentKit = PaymentKit;
